/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppMessages} from '../api'

 export const useQueryGetAppMessages = createReactQueryHook('getAppMessages', getAppMessages)
